import { get, post, deleteReq, requestWithBody } from './fetch';

export const createConfig = (config) => {
  return requestWithBody({ endpoint: 'api/AggregatorConfig/', body: config }, 'POST');
};

export const updateConfig = (config) => {
  return requestWithBody({ endpoint: `api/AggregatorConfig/${config.id}`, body: config }, 'PATCH');
};

export const createConfigItem = (configId, configItem) => {
  return post({ endpoint: `api/AggregatorConfig/${configId}/Item`, body: configItem });
};

export const deleteConfigItem = (configId, propertyName) => {
  return deleteReq({ endpoint: `api/AggregatorConfig/${configId}/Item/${propertyName}` });
};

export const getBranchConfigItems = (configId, branchId) => {
  return get({ endpoint: `api/AggregatorConfig/${configId}/branch/${branchId}/items` });
};

export const updateBranchConfigItem = (configId, branchId, configItem) => {
  return requestWithBody({ endpoint: `api/AggregatorConfig/${configId}/Item/${configItem.propertyName}/branch/${branchId}`, body: configItem }, 'PATCH');
};

export const createBranchConfigItem = (configId, branchId, configItem) => {
  return post({ endpoint: `api/AggregatorConfig/${configId}/Item/${configItem.propertyName}/branch/${branchId}`, body: configItem });
};

export const deleteBranchConfigItem = (configId, branchId, propertyName) => {
  return deleteReq({ endpoint: `api/AggregatorConfig/${configId}/Item/${propertyName}/branch/${branchId}` });
};